import React from 'react';
import ImageScreen from './ImageScreen.jsx';
import { IMAGE_SCREENS } from '../aciData.js';

const ModuleImagePage = ({ moduleKey }) => {
    const config = IMAGE_SCREENS[moduleKey];
    return <ImageScreen {...config} />;
};

export default ModuleImagePage;
